/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetS3AssetRecordQueryVariables = Types.Exact<{
  input: Types.GetRecordInput;
}>;


export type GetS3AssetRecordQuery = { __typename?: 'Query', getS3AssetRecord: { __typename?: 'S3AssetModel', id: string, resourceType?: string | null, contentType: string, presignedGetUrl?: string | null } };

export type InitiateFhirFileUploadMutationVariables = Types.Exact<{
  input: Types.FileInput;
}>;


export type InitiateFhirFileUploadMutation = { __typename?: 'Mutation', initiateFhirFileUpload: { __typename?: 'FileUploadSession', session_id: string, is_multipart: boolean, multipart_upload_id?: string | null, s3_key: string, parts: Array<{ __typename?: 'PartModel', part: number, presigned_url: string }>, expectedHeaders?: { __typename?: 'ExpectedUploadHeaders', contentType: string, contentDisposition: string } | null } };

export type InitiatePacsFileUploadMutationVariables = Types.Exact<{
  input: Types.PacsFileInput;
}>;


export type InitiatePacsFileUploadMutation = { __typename?: 'Mutation', initiatePacsFileUpload: { __typename?: 'FileUploadSession', session_id: string, is_multipart: boolean, multipart_upload_id?: string | null, s3_key: string, parts: Array<{ __typename?: 'PartModel', part: number, presigned_url: string }>, expectedHeaders?: { __typename?: 'ExpectedUploadHeaders', contentType: string, contentDisposition: string } | null } };

export type InitiateAvatarUploadMutationVariables = Types.Exact<{
  input: Types.AvatarUploadInput;
}>;


export type InitiateAvatarUploadMutation = { __typename?: 'Mutation', initiateAvatarUpload: { __typename?: 'FileUploadSession', session_id: string, is_multipart: boolean, multipart_upload_id?: string | null, s3_key: string, parts: Array<{ __typename?: 'PartModel', part: number, presigned_url: string }>, expectedHeaders?: { __typename?: 'ExpectedUploadHeaders', contentType: string, contentDisposition: string } | null } };

export type InitiateAccountAvatarUploadMutationVariables = Types.Exact<{
  input: Types.AccountAvatarUploadInput;
}>;


export type InitiateAccountAvatarUploadMutation = { __typename?: 'Mutation', initiateAccountAvatarUpload: { __typename?: 'FileUploadSession', session_id: string, is_multipart: boolean, multipart_upload_id?: string | null, s3_key: string, parts: Array<{ __typename?: 'PartModel', part: number, presigned_url: string }>, expectedHeaders?: { __typename?: 'ExpectedUploadHeaders', contentType: string, contentDisposition: string } | null } };

export type CompleteFhirFileUploadMutationVariables = Types.Exact<{
  input: Types.MultipartFileUploadSessionInput;
}>;


export type CompleteFhirFileUploadMutation = { __typename?: 'Mutation', completeFhirFileUpload?: string | null };

export type CompletePacsFileUploadMutationVariables = Types.Exact<{
  input: Types.MultipartFileUploadSessionInput;
}>;


export type CompletePacsFileUploadMutation = { __typename?: 'Mutation', completePacsFileUpload?: boolean | null };

export type CompleteAvatarUploadMutationVariables = Types.Exact<{
  input: Types.MultipartFileUploadSessionInput;
}>;


export type CompleteAvatarUploadMutation = { __typename?: 'Mutation', completeAvatarUpload?: { __typename?: 'UserModel', user_id: string, profile_picture?: string | null, updated_at: string } | null };

export type CompleteAccountAvatarUploadMutationVariables = Types.Exact<{
  input: Types.MultipartFileUploadSessionInput;
}>;


export type CompleteAccountAvatarUploadMutation = { __typename?: 'Mutation', completeAccountAvatarUpload?: { __typename?: 'AccountOrSettingWrapper', account_id: string, profile_picture?: string | null, branding_logo_url?: string | null, updated_at?: string | null } | null };

export type DeleteAvatarMutationVariables = Types.Exact<{
  input: Types.DeleteAvatarInput;
}>;


export type DeleteAvatarMutation = { __typename?: 'Mutation', deleteAvatar?: { __typename?: 'UserModel', user_id: string, profile_picture?: string | null, updated_at: string } | null };

export type DeleteAccountAvatarMutationVariables = Types.Exact<{
  input: Types.DeleteAccountAvatarInput;
}>;


export type DeleteAccountAvatarMutation = { __typename?: 'Mutation', deleteAccountAvatar?: { __typename?: 'AccountOrSettingWrapper', account_id: string, profile_picture?: string | null, branding_logo_url?: string | null, updated_at?: string | null } | null };

export type InitiateDiscernMutationVariables = Types.Exact<{
  input: Types.DiscernUploadInput;
}>;


export type InitiateDiscernMutation = { __typename?: 'Mutation', initiateDiscernFileUpload: { __typename?: 'FileUploadSession', session_id: string, s3_key: string, is_multipart: boolean, multipart_upload_id?: string | null, parts: Array<{ __typename?: 'PartModel', part: number, presigned_url: string }>, expectedHeaders?: { __typename?: 'ExpectedUploadHeaders', contentType: string, contentDisposition: string } | null } };

export type CompleteDiscernMutationVariables = Types.Exact<{
  input: Types.MultipartFileUploadSessionInput;
}>;


export type CompleteDiscernMutation = { __typename?: 'Mutation', completeDiscernFileUpload: boolean };


export const GetS3AssetRecordDocument = gql`
    query getS3AssetRecord($input: GetRecordInput!) {
  getS3AssetRecord(input: $input) {
    id
    resourceType
    contentType
    presignedGetUrl
  }
}
    `;
export function useGetS3AssetRecordQuery(baseOptions: Apollo.QueryHookOptions<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables> & ({ variables: GetS3AssetRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>(GetS3AssetRecordDocument, options);
      }
export function useGetS3AssetRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>(GetS3AssetRecordDocument, options);
        }
// @ts-ignore
export function useGetS3AssetRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>;
export function useGetS3AssetRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetS3AssetRecordQuery | undefined, GetS3AssetRecordQueryVariables>;
export function useGetS3AssetRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>(GetS3AssetRecordDocument, options);
        }
export type GetS3AssetRecordQueryHookResult = ReturnType<typeof useGetS3AssetRecordQuery>;
export type GetS3AssetRecordLazyQueryHookResult = ReturnType<typeof useGetS3AssetRecordLazyQuery>;
export type GetS3AssetRecordSuspenseQueryHookResult = ReturnType<typeof useGetS3AssetRecordSuspenseQuery>;
export type GetS3AssetRecordQueryResult = Apollo.QueryResult<GetS3AssetRecordQuery, GetS3AssetRecordQueryVariables>;
export const InitiateFhirFileUploadDocument = gql`
    mutation initiateFhirFileUpload($input: FileInput!) {
  initiateFhirFileUpload(input: $input) {
    session_id
    is_multipart
    multipart_upload_id
    parts {
      part
      presigned_url
    }
    expectedHeaders {
      contentType
      contentDisposition
    }
    s3_key
  }
}
    `;
export type InitiateFhirFileUploadMutationFn = Apollo.MutationFunction<InitiateFhirFileUploadMutation, InitiateFhirFileUploadMutationVariables>;
export function useInitiateFhirFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitiateFhirFileUploadMutation, InitiateFhirFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateFhirFileUploadMutation, InitiateFhirFileUploadMutationVariables>(InitiateFhirFileUploadDocument, options);
      }
export type InitiateFhirFileUploadMutationHookResult = ReturnType<typeof useInitiateFhirFileUploadMutation>;
export type InitiateFhirFileUploadMutationResult = Apollo.MutationResult<InitiateFhirFileUploadMutation>;
export type InitiateFhirFileUploadMutationOptions = Apollo.BaseMutationOptions<InitiateFhirFileUploadMutation, InitiateFhirFileUploadMutationVariables>;
export const InitiatePacsFileUploadDocument = gql`
    mutation initiatePacsFileUpload($input: PacsFileInput!) {
  initiatePacsFileUpload(input: $input) {
    session_id
    is_multipart
    multipart_upload_id
    parts {
      part
      presigned_url
    }
    expectedHeaders {
      contentType
      contentDisposition
    }
    s3_key
  }
}
    `;
export type InitiatePacsFileUploadMutationFn = Apollo.MutationFunction<InitiatePacsFileUploadMutation, InitiatePacsFileUploadMutationVariables>;
export function useInitiatePacsFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitiatePacsFileUploadMutation, InitiatePacsFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiatePacsFileUploadMutation, InitiatePacsFileUploadMutationVariables>(InitiatePacsFileUploadDocument, options);
      }
export type InitiatePacsFileUploadMutationHookResult = ReturnType<typeof useInitiatePacsFileUploadMutation>;
export type InitiatePacsFileUploadMutationResult = Apollo.MutationResult<InitiatePacsFileUploadMutation>;
export type InitiatePacsFileUploadMutationOptions = Apollo.BaseMutationOptions<InitiatePacsFileUploadMutation, InitiatePacsFileUploadMutationVariables>;
export const InitiateAvatarUploadDocument = gql`
    mutation initiateAvatarUpload($input: AvatarUploadInput!) {
  initiateAvatarUpload(input: $input) {
    session_id
    is_multipart
    multipart_upload_id
    parts {
      part
      presigned_url
    }
    expectedHeaders {
      contentType
      contentDisposition
    }
    s3_key
  }
}
    `;
export type InitiateAvatarUploadMutationFn = Apollo.MutationFunction<InitiateAvatarUploadMutation, InitiateAvatarUploadMutationVariables>;
export function useInitiateAvatarUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitiateAvatarUploadMutation, InitiateAvatarUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateAvatarUploadMutation, InitiateAvatarUploadMutationVariables>(InitiateAvatarUploadDocument, options);
      }
export type InitiateAvatarUploadMutationHookResult = ReturnType<typeof useInitiateAvatarUploadMutation>;
export type InitiateAvatarUploadMutationResult = Apollo.MutationResult<InitiateAvatarUploadMutation>;
export type InitiateAvatarUploadMutationOptions = Apollo.BaseMutationOptions<InitiateAvatarUploadMutation, InitiateAvatarUploadMutationVariables>;
export const InitiateAccountAvatarUploadDocument = gql`
    mutation initiateAccountAvatarUpload($input: AccountAvatarUploadInput!) {
  initiateAccountAvatarUpload(input: $input) {
    session_id
    is_multipart
    multipart_upload_id
    parts {
      part
      presigned_url
    }
    expectedHeaders {
      contentType
      contentDisposition
    }
    s3_key
  }
}
    `;
export type InitiateAccountAvatarUploadMutationFn = Apollo.MutationFunction<InitiateAccountAvatarUploadMutation, InitiateAccountAvatarUploadMutationVariables>;
export function useInitiateAccountAvatarUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitiateAccountAvatarUploadMutation, InitiateAccountAvatarUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateAccountAvatarUploadMutation, InitiateAccountAvatarUploadMutationVariables>(InitiateAccountAvatarUploadDocument, options);
      }
export type InitiateAccountAvatarUploadMutationHookResult = ReturnType<typeof useInitiateAccountAvatarUploadMutation>;
export type InitiateAccountAvatarUploadMutationResult = Apollo.MutationResult<InitiateAccountAvatarUploadMutation>;
export type InitiateAccountAvatarUploadMutationOptions = Apollo.BaseMutationOptions<InitiateAccountAvatarUploadMutation, InitiateAccountAvatarUploadMutationVariables>;
export const CompleteFhirFileUploadDocument = gql`
    mutation completeFhirFileUpload($input: MultipartFileUploadSessionInput!) {
  completeFhirFileUpload(input: $input)
}
    `;
export type CompleteFhirFileUploadMutationFn = Apollo.MutationFunction<CompleteFhirFileUploadMutation, CompleteFhirFileUploadMutationVariables>;
export function useCompleteFhirFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompleteFhirFileUploadMutation, CompleteFhirFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteFhirFileUploadMutation, CompleteFhirFileUploadMutationVariables>(CompleteFhirFileUploadDocument, options);
      }
export type CompleteFhirFileUploadMutationHookResult = ReturnType<typeof useCompleteFhirFileUploadMutation>;
export type CompleteFhirFileUploadMutationResult = Apollo.MutationResult<CompleteFhirFileUploadMutation>;
export type CompleteFhirFileUploadMutationOptions = Apollo.BaseMutationOptions<CompleteFhirFileUploadMutation, CompleteFhirFileUploadMutationVariables>;
export const CompletePacsFileUploadDocument = gql`
    mutation completePacsFileUpload($input: MultipartFileUploadSessionInput!) {
  completePacsFileUpload(input: $input)
}
    `;
export type CompletePacsFileUploadMutationFn = Apollo.MutationFunction<CompletePacsFileUploadMutation, CompletePacsFileUploadMutationVariables>;
export function useCompletePacsFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompletePacsFileUploadMutation, CompletePacsFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletePacsFileUploadMutation, CompletePacsFileUploadMutationVariables>(CompletePacsFileUploadDocument, options);
      }
export type CompletePacsFileUploadMutationHookResult = ReturnType<typeof useCompletePacsFileUploadMutation>;
export type CompletePacsFileUploadMutationResult = Apollo.MutationResult<CompletePacsFileUploadMutation>;
export type CompletePacsFileUploadMutationOptions = Apollo.BaseMutationOptions<CompletePacsFileUploadMutation, CompletePacsFileUploadMutationVariables>;
export const CompleteAvatarUploadDocument = gql`
    mutation completeAvatarUpload($input: MultipartFileUploadSessionInput!) {
  completeAvatarUpload(input: $input) {
    user_id
    profile_picture
    updated_at
  }
}
    `;
export type CompleteAvatarUploadMutationFn = Apollo.MutationFunction<CompleteAvatarUploadMutation, CompleteAvatarUploadMutationVariables>;
export function useCompleteAvatarUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAvatarUploadMutation, CompleteAvatarUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAvatarUploadMutation, CompleteAvatarUploadMutationVariables>(CompleteAvatarUploadDocument, options);
      }
export type CompleteAvatarUploadMutationHookResult = ReturnType<typeof useCompleteAvatarUploadMutation>;
export type CompleteAvatarUploadMutationResult = Apollo.MutationResult<CompleteAvatarUploadMutation>;
export type CompleteAvatarUploadMutationOptions = Apollo.BaseMutationOptions<CompleteAvatarUploadMutation, CompleteAvatarUploadMutationVariables>;
export const CompleteAccountAvatarUploadDocument = gql`
    mutation completeAccountAvatarUpload($input: MultipartFileUploadSessionInput!) {
  completeAccountAvatarUpload(input: $input) {
    account_id
    profile_picture
    branding_logo_url
    updated_at
  }
}
    `;
export type CompleteAccountAvatarUploadMutationFn = Apollo.MutationFunction<CompleteAccountAvatarUploadMutation, CompleteAccountAvatarUploadMutationVariables>;
export function useCompleteAccountAvatarUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAccountAvatarUploadMutation, CompleteAccountAvatarUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAccountAvatarUploadMutation, CompleteAccountAvatarUploadMutationVariables>(CompleteAccountAvatarUploadDocument, options);
      }
export type CompleteAccountAvatarUploadMutationHookResult = ReturnType<typeof useCompleteAccountAvatarUploadMutation>;
export type CompleteAccountAvatarUploadMutationResult = Apollo.MutationResult<CompleteAccountAvatarUploadMutation>;
export type CompleteAccountAvatarUploadMutationOptions = Apollo.BaseMutationOptions<CompleteAccountAvatarUploadMutation, CompleteAccountAvatarUploadMutationVariables>;
export const DeleteAvatarDocument = gql`
    mutation deleteAvatar($input: DeleteAvatarInput!) {
  deleteAvatar(input: $input) {
    user_id
    profile_picture
    updated_at
  }
}
    `;
export type DeleteAvatarMutationFn = Apollo.MutationFunction<DeleteAvatarMutation, DeleteAvatarMutationVariables>;
export function useDeleteAvatarMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAvatarMutation, DeleteAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAvatarMutation, DeleteAvatarMutationVariables>(DeleteAvatarDocument, options);
      }
export type DeleteAvatarMutationHookResult = ReturnType<typeof useDeleteAvatarMutation>;
export type DeleteAvatarMutationResult = Apollo.MutationResult<DeleteAvatarMutation>;
export type DeleteAvatarMutationOptions = Apollo.BaseMutationOptions<DeleteAvatarMutation, DeleteAvatarMutationVariables>;
export const DeleteAccountAvatarDocument = gql`
    mutation deleteAccountAvatar($input: DeleteAccountAvatarInput!) {
  deleteAccountAvatar(input: $input) {
    account_id
    profile_picture
    branding_logo_url
    updated_at
  }
}
    `;
export type DeleteAccountAvatarMutationFn = Apollo.MutationFunction<DeleteAccountAvatarMutation, DeleteAccountAvatarMutationVariables>;
export function useDeleteAccountAvatarMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountAvatarMutation, DeleteAccountAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountAvatarMutation, DeleteAccountAvatarMutationVariables>(DeleteAccountAvatarDocument, options);
      }
export type DeleteAccountAvatarMutationHookResult = ReturnType<typeof useDeleteAccountAvatarMutation>;
export type DeleteAccountAvatarMutationResult = Apollo.MutationResult<DeleteAccountAvatarMutation>;
export type DeleteAccountAvatarMutationOptions = Apollo.BaseMutationOptions<DeleteAccountAvatarMutation, DeleteAccountAvatarMutationVariables>;
export const InitiateDiscernDocument = gql`
    mutation InitiateDiscern($input: DiscernUploadInput!) {
  initiateDiscernFileUpload(input: $input) {
    session_id
    s3_key
    is_multipart
    multipart_upload_id
    parts {
      part
      presigned_url
    }
    expectedHeaders {
      contentType
      contentDisposition
    }
  }
}
    `;
export type InitiateDiscernMutationFn = Apollo.MutationFunction<InitiateDiscernMutation, InitiateDiscernMutationVariables>;
export function useInitiateDiscernMutation(baseOptions?: Apollo.MutationHookOptions<InitiateDiscernMutation, InitiateDiscernMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateDiscernMutation, InitiateDiscernMutationVariables>(InitiateDiscernDocument, options);
      }
export type InitiateDiscernMutationHookResult = ReturnType<typeof useInitiateDiscernMutation>;
export type InitiateDiscernMutationResult = Apollo.MutationResult<InitiateDiscernMutation>;
export type InitiateDiscernMutationOptions = Apollo.BaseMutationOptions<InitiateDiscernMutation, InitiateDiscernMutationVariables>;
export const CompleteDiscernDocument = gql`
    mutation CompleteDiscern($input: MultipartFileUploadSessionInput!) {
  completeDiscernFileUpload(input: $input)
}
    `;
export type CompleteDiscernMutationFn = Apollo.MutationFunction<CompleteDiscernMutation, CompleteDiscernMutationVariables>;
export function useCompleteDiscernMutation(baseOptions?: Apollo.MutationHookOptions<CompleteDiscernMutation, CompleteDiscernMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteDiscernMutation, CompleteDiscernMutationVariables>(CompleteDiscernDocument, options);
      }
export type CompleteDiscernMutationHookResult = ReturnType<typeof useCompleteDiscernMutation>;
export type CompleteDiscernMutationResult = Apollo.MutationResult<CompleteDiscernMutation>;
export type CompleteDiscernMutationOptions = Apollo.BaseMutationOptions<CompleteDiscernMutation, CompleteDiscernMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetS3AssetRecord = withQueryResponseHandler(useGetS3AssetRecordQuery);
export const useInitiateFhirFileUpload = withMutationResponseHandler(useInitiateFhirFileUploadMutation, "initiateFhirFileUpload");
export const useInitiatePacsFileUpload = withMutationResponseHandler(useInitiatePacsFileUploadMutation, "initiatePacsFileUpload");
export const useInitiateAvatarUpload = withMutationResponseHandler(useInitiateAvatarUploadMutation, "initiateAvatarUpload");
export const useInitiateAccountAvatarUpload = withMutationResponseHandler(useInitiateAccountAvatarUploadMutation, "initiateAccountAvatarUpload");
export const useCompleteFhirFileUpload = withMutationResponseHandler(useCompleteFhirFileUploadMutation, "completeFhirFileUpload");
export const useCompletePacsFileUpload = withMutationResponseHandler(useCompletePacsFileUploadMutation, "completePacsFileUpload");
export const useCompleteAvatarUpload = withMutationResponseHandler(useCompleteAvatarUploadMutation, "completeAvatarUpload");
export const useCompleteAccountAvatarUpload = withMutationResponseHandler(useCompleteAccountAvatarUploadMutation, "completeAccountAvatarUpload");
export const useDeleteAvatar = withMutationResponseHandler(useDeleteAvatarMutation, "deleteAvatar");
export const useDeleteAccountAvatar = withMutationResponseHandler(useDeleteAccountAvatarMutation, "deleteAccountAvatar");
export const useInitiateDiscern = withMutationResponseHandler(useInitiateDiscernMutation, "initiateDiscern");
export const useCompleteDiscern = withMutationResponseHandler(useCompleteDiscernMutation, "completeDiscern");